export default __webpack_public_path__ + "static/17-6b947365e055cae656f0a79a24b97dca.jpg";